import styles from './ActionBar.module.scss';
import { ContactButton } from '@/components/_shared/buttons/ContactButton/ContactButton';
import { FollowButton } from '@/components/_shared/buttons/FollowButton/FollowButton';
import type { OrganizerWithFollowStatus } from '@/components/OrganizerCard/types';

export type ActionBarProps = {
  organizer: OrganizerWithFollowStatus;
  eventId: string;
  pageArea?: string;
};

export const ActionBar = ({ organizer, eventId, pageArea }: ActionBarProps) => {
  return (
    <div className={styles.actionBar}>
      <ContactButton organizerId={organizer.id} eventId={eventId} organizerName={organizer.name} />
      <FollowButton organizer={organizer} pageArea={pageArea} />
    </div>
  );
};
